import { render, staticRenderFns } from "./CustomerViewBillingAddresses.vue?vue&type=template&id=35c1a6a2&scoped=true"
import script from "./CustomerViewBillingAddresses.vue?vue&type=script&lang=js"
export * from "./CustomerViewBillingAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1a6a2",
  null
  
)

export default component.exports